import { render } from "./Path.vue?vue&type=template&id=6a901570&scoped=true"
import script from "./Path.vue?vue&type=script&lang=js"
export * from "./Path.vue?vue&type=script&lang=js"

import "./Path.vue?vue&type=style&index=0&id=6a901570&scoped=true&lang=css"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6a901570"]])

export default __exports__